import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

function ImageViewer() {
  const navigate = useNavigate();
  const location = useLocation();
  const [copied, setCopied] = useState(false);

  const params = new URLSearchParams(location.search);
  const imageUrl = params.get("url");

  // Copy URL
  const copyToClipboard = () => {
    if (!imageUrl) return;

    navigator.clipboard.writeText(imageUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  // Download image
  const downloadImage = async () => {
    try {
      const res = await fetch(imageUrl);
      const blob = await res.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = imageUrl.split("/").pop();
      link.click();

      window.URL.revokeObjectURL(blobUrl);
    } catch {
      alert("Download failed");
    }
  };

  // Logout
  const handleLogout = () => {
    navigate("/"); // Navigate to login page
  };

  return (
    <div style={styles.page}>
      
      {/* HEADER */}
      <header style={styles.header}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <button style={styles.backBtn} onClick={() => navigate("/gallery")}>
            ← Back
          </button>
          <h2 style={styles.title}>Image Viewer</h2>
        </div>

        <button style={styles.logoutBtn} onClick={handleLogout}>
          Logout
        </button>
      </header>

      {/* CONTENT */}
      <main style={styles.wrapper}>
        <div style={styles.card}>

          {/* URL BAR */}
          <div style={styles.urlBar}>
            <input
              value={imageUrl || ""}
              readOnly
              style={styles.input}
            />

            <button
              onClick={copyToClipboard}
              style={{
                ...styles.actionBtn,
                background: copied ? "#16a34a" : "#2563eb"
              }}
            >
              {copied ? "Copied!" : "Copy"}
            </button>

            <button
              onClick={downloadImage}
              style={{ ...styles.actionBtn, background: "#0f172a" }}
            >
              Download
            </button>
          </div>

          {/* IMAGE */}
          <div style={styles.imageBox}>
            <img
              src={imageUrl}
              alt="Selected"
              style={styles.image}
            />
          </div>

        </div>
      </main>

    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "#f1f5f9"
  },

  header: {
    background: "#0f172a",
    padding: "18px 30px",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },

  backBtn: {
    background: "transparent",
    border: "none",
    color: "#93c5fd",
    fontSize: "15px",
    cursor: "pointer",
    marginRight: "14px"
  },

  logoutBtn: {
    backgroundColor: "#dc2626",
    border: "none",
    color: "#fff",
    padding: "6px 14px",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "14px",
    transition: "background 0.2s, transform 0.2s"
  },

  title: {
    margin: 0
  },

  wrapper: {
    display: "flex",
    justifyContent: "center",
    padding: "50px 20px"
  },

  card: {
    background: "#fff",
    width: "100%",
    maxWidth: "900px",
    borderRadius: "14px",
    padding: "30px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)"
  },

  urlBar: {
    display: "flex",
    gap: "10px",
    marginBottom: "25px"
  },

  input: {
    flex: 1,
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #d1d5db",
    fontSize: "14px"
  },

  actionBtn: {
    padding: "0 16px",
    borderRadius: "8px",
    border: "none",
    color: "#fff",
    cursor: "pointer",
    fontSize: "14px"
  },

  imageBox: {
    textAlign: "center"
  },

  image: {
    maxWidth: "100%",
    maxHeight: "600px",
    borderRadius: "14px",
    boxShadow: "0 8px 30px rgba(0,0,0,0.15)"
  }
};

export default ImageViewer;
